export const questions = [
  {
    "id": "Q1",
    "section": "Relationship with leadership",
    "description": "Strong relationships with senior leadership give you permission to lead, shape strategy, and be seen as a strategic equal. You're aligned on ambition, trusted to deliver outcomes not just outputs. But when the relationship is weak, marketing turns into a battle for relevance, budget, and understanding. That constant defence mode drains energy, creativity, joy and limits your ability to turn vision into impact.",
    "text": "I feel trusted by the leadership team to make strategic decisions that impact business growth"
  },
  {
    "id": "Q2",
    "section": "Relationship with leadership",
    "text": "I have regular, outcome-focused conversations with the CEO, CFO or other senior peers about how marketing contributes to commercial success"
  },
  {
    "id": "Q3",
    "section": "Relationship with leadership",
    "text": "I feel that marketing has a clear seat at the leadership table, early and often in strategic planning"
  },
  {
    "id": "Q4",
    "section": "Relationship with leadership",
    "text": "Other senior leaders understand the value of brand and demand, and how we all work together to drive growth"
  },
  {
    "id": "Q5",
    "section": "Relationship with leadership",
    "text": "When marketing performs well, that success is recognised and celebrated at a leadership level"
  },
  {
    "id": "Q6",
    "section": "Relationship with leadership",
    "text": "I feel confident and equipped to challenge leaderships thinking when necessary and that input respected"
  },
  {
    "id": "Q7",
    "section": "Relationship with leadership",
    "text": "I feel energised after leadership meetings or board level conversations"
  },
  {
    "id": "Q8",
    "section": "Relationship with the business",
    "description": "Marketing doesn't operate in isolation. To lead with impact, you need a clear, current view of the business: its goals, challenges, product performance, and operating context. Are you in high-growth mode or under pressure? Are priorities clear or constantly shifting? When you're in tune with the rhythm of the business, your plans land better. When you're not, even great marketing can miss the moment.",
    "text": "I have a clear understanding of the business's short and long-term growth goals"
  },
  {
    "id": "Q9",
    "section": "Relationship with the business",
    "text": "I feel confident articulating how marketing supports the business's most urgent commercial priorities"
  },
  {
    "id": "Q10",
    "section": "Relationship with the business",
    "text": "I have visibility into how the business is performing across key areas: sales, product, operations, finance, marketing and so forth"
  },
  {
    "id": "Q11",
    "section": "Relationship with the business",
    "text": "There's consistency and clarity in the strategic direction shared by senior leadership"
  },
  {
    "id": "Q12",
    "section": "Relationship with the business",
    "text": "I'm aware of any upcoming M&A activity, organisational change, or structural shifts that could impact marketing's role"
  },
  {
    "id": "Q13",
    "section": "Relationship with the business",
    "text": "I feel the business is in a healthy place, culturally, financially, and operationally"
  },
  {
    "id": "Q14",
    "section": "Relationship with the business",
    "text": "I believe our current product or service offering is competitively strong in our market"
  },
  {
    "id": "Q15",
    "section": "Relationship with the market",
    "description": "This is your connection to customers, competitors, and the trends reshaping your world. When this relationship is strong, you don't just respond to the market - you help shape it. You spot opportunities early, influence leadership with insight, and stay ahead of change. But when you're out of sync, you risk guessing, reacting, or missing what really matters.",
    "text": "I have a clear, current understanding of what matters most to our customers and prospects"
  },
  {
    "id": "Q16",
    "section": "Relationship with the market",
    "text": "I regularly track and review how our competitors are positioning and evolving their offerings"
  },
  {
    "id": "Q17",
    "section": "Relationship with the market",
    "text": "I understand how buying behaviours are shifting in our category"
  },
  {
    "id": "Q18",
    "section": "Relationship with the market",
    "text": "I feel confident speaking on behalf of the market inside leadership conversations"
  },
  {
    "id": "Q19",
    "section": "Relationship with the market",
    "text": "I have reliable systems or methods for capturing market intelligence on an ongoing basis"
  },
  {
    "id": "Q20",
    "section": "Relationship with the market",
    "text": "I proactively share market trends, customer insights, or competitive moves with the wider business"
  },
  {
    "id": "Q21",
    "section": "Relationship with the market",
    "text": "I feel that my understanding of the market gives me an edge when shaping strategy or messaging"
  },
  {
    "id": "Q22",
    "section": "Relationship with partners",
    "description": "No CMO succeeds alone. The strength of your external partners, agencies, platforms, tech vendors directly impacts your ability to deliver, innovate, and scale. This isn't just about outputs. It's about trust, chemistry, and shared ambition. When it works, you move faster and think bigger. When it doesn't, friction builds, energy drains and the grind takes over.",
    "text": "I trust my key agency and platform partners to consistently deliver high-quality, on-brand work"
  },
  {
    "id": "Q23",
    "section": "Relationship with partners",
    "text": "I feel our external partners bring fresh ideas, strategic challenge, and proactive thinking"
  },
  {
    "id": "Q24",
    "section": "Relationship with partners",
    "text": "Our tech stack is structured to support automation, measurement, and efficient campaign execution"
  },
  {
    "id": "Q25",
    "section": "Relationship with partners",
    "text": "I have clarity on which external partners we rely on for which parts of our marketing engine"
  },
  {
    "id": "Q26",
    "section": "Relationship with partners",
    "text": "We're getting a good return on investment from our external marketing spend"
  },
  {
    "id": "Q27",
    "section": "Relationship with partners",
    "text": "Our partners understand our business goals and tailor their approach accordingly"
  },
  {
    "id": "Q28",
    "section": "Relationship with partners",
    "text": "I feel these relationships increase the overall capability and performance of the marketing function"
  },
  {
    "id": "Q29",
    "section": "Relationship with your team",
    "description": "Your team is where leadership becomes visible. It reflects how clearly you set direction, structure capability, and empower growth, not just of the business, but of people. When the relationship is strong, you build clarity, energy, and pride. When it's weak, confusion, burnout, and disengagement creep in. This is where your vision becomes reality and your impact becomes legacy.",
    "text": "I feel confident that my team is clear on our goals and their role in achieving them"
  },
  {
    "id": "Q30",
    "section": "Relationship with your team",
    "text": "I believe our team has the right mix of skills, mindsets, and capacity to deliver at the level required"
  },
  {
    "id": "Q31",
    "section": "Relationship with your team",
    "text": "I have a structured, intentional approach to developing my team members"
  },
  {
    "id": "Q32",
    "section": "Relationship with your team",
    "text": "I feel proud of how our team shows up, collaborates, and represents marketing across the business"
  },
  {
    "id": "Q33",
    "section": "Relationship with your team",
    "text": "I regularly celebrate progress and recognise great work across the team"
  },
  {
    "id": "Q34",
    "section": "Relationship with your team",
    "text": "I'm balancing internal delivery with agency or partner support in a way that builds team confidence and scale"
  },
  {
    "id": "Q35",
    "section": "Relationship with your team",
    "text": "I feel the team trusts me to lead, support, and advocate for them"
  },
  {
    "id": "Q36",
    "section": "Relationship with your role",
    "description": "This is the relationship between you and the seat you hold, how your role is defined, perceived, and experienced day to day. When it's strong, your role becomes a platform for impact. When it's not, you're stuck between ambition and firefighting, reacting instead of leading. Clear scope and strategic altitude give you confidence. Without them, the job becomes a grind.",
    "text": "I feel my role is clearly defined, with appropriate scope and expectations"
  },
  {
    "id": "Q37",
    "section": "Relationship with your role",
    "text": "I spend the majority of my time on the right things, strategic, high-impact work"
  },
  {
    "id": "Q38",
    "section": "Relationship with your role",
    "text": "I feel the business understands and respects the breadth of my role"
  },
  {
    "id": "Q39",
    "section": "Relationship with your role",
    "text": "I have the autonomy to shape how I deliver impact within my role"
  },
  {
    "id": "Q40",
    "section": "Relationship with your role",
    "text": "I feel energised by the day to day demands of the role"
  },
  {
    "id": "Q41",
    "section": "Relationship with your role",
    "text": "I believe my role is evolving in line with the business and my own growth ambitions"
  },
  {
    "id": "Q42",
    "section": "Relationship with your role",
    "text": "If someone asked me to describe the impact I'm making in this role, would I be proud of the answer"
  },
  {
    "id": "Q43",
    "section": "Relationship with yourself",
    "description": "This is the relationship that sets the tone for every other one, your mindset, energy, belief, and clarity of ambition. When it's strong, you lead with calm conviction and creative courage. When it's not, doubt creeps in, burnout builds, and you stop growing. Staying connected to yourself means owning your development, trusting your instincts, and protecting the joy that fuels your leadership.",
    "text": "I feel confident in my ability to lead, influence and make an impact at this level"
  },
  {
    "id": "Q44",
    "section": "Relationship with yourself",
    "text": "I regularly invest time in my own learning, development and growth"
  },
  {
    "id": "Q45",
    "section": "Relationship with yourself",
    "text": "I have a clear vision for my own career direction over the next 1-3 years"
  },
  {
    "id": "Q46",
    "section": "Relationship with yourself",
    "text": "I feel I'm managing my time and energy in a way that supports both performance and wellbeing"
  },
  {
    "id": "Q47",
    "section": "Relationship with yourself",
    "text": "I actively seek out feedback and remain open to challenge and different perspectives"
  },
  {
    "id": "Q48",
    "section": "Relationship with yourself",
    "text": "I recognise and celebrate my own progress and achievements"
  },
  {
    "id": "Q49",
    "section": "Relationship with yourself",
    "text": "I feel proud of the way I'm showing up as a leader day to day"
  }
]